
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navigation from './pages/eximpe-main/Navigation';
import Footer from './pages/eximpe-main/Footer';
import GlobalCollection from './pages/eximpe-main/global-collection-page/GlobalCollectionPage';
import AboutPage from './pages/eximpe-main/AboutEximpePage';
import ContactPage from './pages/eximpe-main/ContactUsPage';
import DemoPage from './pages/eximpe-main/RequestdemoPage';
import Homepage from './pages/eximpe-main/global-trade-page/GlobalTradePage';
// import Financing from './pages/eximpe-main/FinancePage';
import Redressal from './pages/eximpe-main/RedressalPage';
import PrivacyPolicy from './pages/eximpe-main/PrivacyPolicyPage';
import TandC from './pages/eximpe-main/TermsPage';
import LinkTree from './pages/eximpe-linktree/LinkTreePage';
import Landing from './pages/eximpe-landing-pacb/LandingPage';
import SwiftFinder from './pages/eximpe-tools/SwiftCodeFinderPage';
import InvoiceGenerator from './pages/eximpe-tools/InvoiceGenerator';
import HSCodeFinder from './pages/eximpe-tools/HScode';
import BlogSection from './pages/eximpe-blog/BlogsSection';
import BlogView from './pages/eximpe-blog/BlogView';

const MainLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <Navigation />
    {children}
    <Footer />
  </>
);

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout><GlobalCollection /></MainLayout>} />
        <Route path="/about-eximpe" element={<MainLayout><AboutPage /></MainLayout>} />
        <Route path="/contact-us" element={<MainLayout><ContactPage /></MainLayout>} />
        <Route path="/request-demo" element={<MainLayout><DemoPage /></MainLayout>} />
        <Route path="/global-trade-account" element={<MainLayout><Homepage /></MainLayout>} />
        {/* <Route path="/financing" element={<MainLayout><Financing /></MainLayout>} /> */}
        <Route path="/grievance-redressal-policy" element={<MainLayout><Redressal /></MainLayout>} />
        <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
        <Route path="/terms-and-conditions" element={<MainLayout><TandC /></MainLayout>} />
        <Route path="/social-links" element={<MainLayout><LinkTree /></MainLayout>} />
        <Route path="/blog" element={<MainLayout><BlogSection /></MainLayout>} />
        <Route
          path="/blog/:category/:slug"
          element={<MainLayout><BlogView /></MainLayout>}
        />
        <Route path="/swift-code-finder/*" element={<MainLayout><SwiftFinder /></MainLayout>} />
        <Route path="/invoice-generator/*" element={<MainLayout><InvoiceGenerator /></MainLayout>} />
        <Route path="/hscode/*" element={<MainLayout><HSCodeFinder /></MainLayout>} />

        {/* Route without nav/footer */}
        <Route path="/landing" element={<Landing />} />

        {/* Catch-all → redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
